/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCookieIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-cookie"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 22.8Q9.75 22.8 7.79 21.95Q5.83 21.1 4.36 19.64Q2.9 18.18 2.05 16.2Q1.2 14.22 1.2 12Q1.2 9.85 2.02 7.88Q2.85 5.9 4.31 4.4Q5.78 2.9 7.78 2.02Q9.78 1.15 12.13 1.18Q13.05 1.2 13.55 1.59Q14.05 1.98 14.22 2.98Q14.47 4.38 15.47 5.36Q16.48 6.35 17.85 6.55Q18.63 6.67 19.01 7.08Q19.4 7.47 19.6 8.35Q19.75 9.05 20.2 9.59Q20.65 10.13 21.25 10.47Q22.07 10.93 22.46 11.55Q22.85 12.18 22.75 13.1Q22.55 15.13 21.64 16.89Q20.73 18.65 19.29 19.96Q17.85 21.27 15.97 22.04Q14.1 22.8 12 22.8ZM10.5 10.15Q11.2 10.15 11.68 9.66Q12.15 9.18 12.15 8.5Q12.15 7.8 11.68 7.33Q11.2 6.85 10.5 6.85Q9.82 6.85 9.34 7.33Q8.85 7.8 8.85 8.5Q8.85 9.18 9.34 9.66Q9.82 10.15 10.5 10.15ZM8.5 15.15Q9.2 15.15 9.68 14.66Q10.15 14.18 10.15 13.5Q10.15 12.8 9.68 12.32Q9.2 11.85 8.5 11.85Q7.83 11.85 7.34 12.32Q6.85 12.8 6.85 13.5Q6.85 14.18 7.34 14.66Q7.83 15.15 8.5 15.15ZM15 16.2Q15.5 16.2 15.85 15.85Q16.2 15.5 16.2 15Q16.2 14.5 15.85 14.15Q15.5 13.8 15 13.8Q14.5 13.8 14.15 14.15Q13.8 14.5 13.8 15Q13.8 15.5 14.15 15.85Q14.5 16.2 15 16.2Z" fill={color} />
    </svg>
  );
}
